// App-wide constants shared by the brand banner + footer.
//
// The Architect's Versioning & Truth-Stamp brief (v1.8) asks for a
// single, easily updatable version string surfaced in the top header
// stripey band. This module is the one place to bump that string: both
// the brand banner and the footer tag read from here, so they never
// drift out of sync.

export const APP_VERSION = 'v2.3';

// Build stamp is bumped per brief cycle, not per commit — the preview
// URL (branch alias) already points at the latest deployment, so this
// just names which Architect brief the current UI corresponds to.
export const BUILD_STAMP  = '2026-04-22';

// Build tag surfaces in the Hazard Stripe band — names the current
// architectural cut. v2.3 = Minting Cockpit: market creation is
// refactored into a Citizen-gated Sovereign-Industrial cockpit with
// three ribs — the Collateral Chamber (Bond Lock visual with Locking
// Collateral animation), the Reality Blueprint (Primary Oracle URL,
// Resolution Clause, outcome array), and the Projection Feed sidebar
// (Maker Fee + Projected Earnings from Estimated Volume × 0.01). The
// Hazard Stripe CTA is disabled for sub-Citizen tiers; the modal's
// own TierGate panel is the internal safety net.
export const BUILD_TAG    = 'MINTING_COCKPIT';

export const ARCHITECT    = 'DROMIDE';

// ─── Build Reference ──────────────────────────────────────────────────
// Re-exported from src/build-info.ts, which is AUTO-GENERATED by the
// scripts/write-build-info.js prebuild hook. The prebuild reads the
// Vercel platform env vars (VERCEL_GIT_COMMIT_SHA / VERCEL_GIT_COMMIT_REF)
// on deploy and falls back to `git rev-parse` locally. This bypasses
// CRA's REACT_APP_ env-var filtering entirely — the SHA is baked in as
// a plain TypeScript constant that survives the webpack build.
export { BUILD_SHA, BUILD_BRANCH, BUILD_TIME, BUILD_STAMP_HUMAN } from './build-info';
